import { View } from 'foundations-components/components/View';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
export const MacrosMenuLoadingState = () => {
  return /*#__PURE__*/_jsx(View, {
    "data-test-id": "macros-menu-loading-state",
    blockSize: "300px",
    children: /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      layout: "centered"
    })
  });
};
MacrosMenuLoadingState.displayName = 'MacrosMenuLoadingState';